//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poFinishProdWorks', {
//        templateUrl: 'views/components/views/poFinishProdWorks/poFinishProdWorks.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'poFinishProdWorksService', function ($stateParams, poFinishProdWorksService) {
//            const vm = this;
//            let p2PoFinishProdKeyno = $stateParams.p2_pofinishprod_keyno;

//            vm.model = {
//                itemsListProductWorks: []
//            };

//            async function loadProductWorks() {
//                vm.model.itemsListProductWorks = await poFinishProdWorksService.listProductWorks({ p2_pofinishprod_keyno: p2PoFinishProdKeyno });
//            }
            
//            vm.$onInit = async function () {
//                loadProductWorks();
//            }
//        }]
//    });
//})();
